import { createContext, useContext } from 'react';

export const LdFlags = createContext<Record<string, boolean>>({});

export const useLdFlags = (): Record<string, boolean> => {
  return useContext(LdFlags);
};
